
  <div class="card">
    <div class="card-header">
      <h2 class="card-title text-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-vector-pen" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"/>
        <path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086z"/>
      </svg>
      Firma Digital</h2>
    </div>
    <div class="card-body">
      <div *ngIf="progress==0">
        <div class="row">
          <div class="col-12">

      
            <p class="text-info">Para poder solicitar la Firma Electrónica verifica los siguientes requisitos:</p>

            <div *ngIf="canSignDocuments; else elseBlockCredit">
              <p class="text-success">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                </svg> Créditos disponibles:  {{ credits - thisMonthUsedCredits }} de {{ credits}}
              </p>
            </div>
            <ng-template #elseBlockCredit>
              <p class="text-danger">No cuentas con créditos disponibles para firma electrónica, {{thisMonthUsedCredits}} de {{credits}} usados.</p>
            </ng-template>

            <div *ngIf="validPdf || fileBlob; else elseBlock" >
              <p class="text-success">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
              </svg> Documento
            </p>
            </div>
            <ng-template #elseBlock>
              <p class="text-danger">Agrega el Documento(pdf) que se firmara.</p>
            </ng-template>
      
            <div *ngIf="numSigners >0 ; else elseBlock1" >
              <p class="text-success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
              </svg> Firmantes</p>
            </div>
            <ng-template #elseBlock1>
              <p class="text-danger">Agrega por lo menos un Firmante.</p>
            </ng-template>
      
            <div *ngIf="numViewers >0 ; else elseBlock2" >
              <p class="text-success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
              </svg> Espectador</p>
            </div>
            <ng-template #elseBlock2>
                <p class="text-danger">Agrega por lo menos un Espectador.</p>
            </ng-template>
      
            <div *ngIf="(validPdf && !fileBlob) && numSigners>0 && numViewers>0 && canSignDocuments" class="p-3">
              <button class="btn btn-success btn-lg" (click)="upload()">
                  Solicitar Firmas 1
              </button>
            </div>

            <div *ngIf="(!validPdf && fileBlob) && numSigners>0 && numViewers>0 && canSignDocuments" class="p-3">
              <button class="btn btn-success btn-lg" (click)="uploadContract()">
                  Solicitar Firmas 2
              </button>
            </div>   
            
          </div>
        </div>
      
        <nav ngbNav #nav="ngbNav" class="nav-tabs">
          <ng-container ngbNavItem>
      
            <a ngbNavLink>Preparación <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-data-fill" viewBox="0 0 16 16">
              <path d="M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5"/>
              <path d="M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585q.084.236.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5q.001-.264.085-.5M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"/>
            </svg></a>
            <ng-template ngbNavContent>
      
              <div class="mx-auto p-3" style="width: 400px;">
                <h5>Preparación del Documento</h5>
              </div>
      
                
      
              <div class="mb-3">
                <label class="form-label col" for="signMessage">Mensaje:</label>
                <input type="text" class="form-control" id="signMessage" placeholder="Mensaje para los firmantes" name="email" [(ngModel)]="mifielData.message_for_signers">
                <div class="form-text">Este mensaje le llegara a todos los que deban firmar el documento.</div>
              </div>
      
              <div class="mb-3">
                <label class="control-label col-sm-2" for="signValidDays">Dias de validez:</label>
                <input type="number" class="form-control" id="pwd" name="signValidDays" value="5" [(ngModel)]="mifielData.days_to_expire">
                <div class="form-text">Establece cuantos dias se tendran para firmar el documento.</div>
              </div>
      
              <!-- Firmantes -->
              <div>
                <div class="mx-auto p-2" style="width: 300px;">
                  <h4>Firmantes</h4>
                </div>
                
                <button class="btn btn-sm btn-outline-primary" (click)="openSignature()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-add" viewBox="0 0 16 16">
                      <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                      <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4"/>
                    </svg> Agregar
                </button>

                <button class="btn btn-sm btn-outline-primary" (click)="openSignatureBulk()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64"/>
                  </svg> Cargar Excel
                </button>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Correo</th>
                      <th scope="col">RFC</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let signatory of mifielData.signatories; let i = index">
                      <th scope="row">{{ i + 1}}</th>
                      <td>{{signatory[1]}}</td>
                      <td>{{signatory[0]}}</td>
                      <td>{{signatory[2]}}</td>
                      <td>
                        <button class="btn " (click)="deleteSignatory(i)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-dash" viewBox="0 0 16 16">
                              <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                            </svg>Eliminar
                        </button>
                      </td>
                    </tr>  
                  </tbody>
                </table>
              </div>
      
              <!-- Reviwers -->
              <div>
                <div class="mx-auto p-2" style="width: 300px;">
                  <h4>Espectadores</h4>
                </div>
                <button class="btn btn-sm btn-outline-primary" (click)="openReviewer()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-add" viewBox="0 0 16 16">
                      <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                      <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4"/>
                    </svg> Agregar
                </button>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Correo</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of mifielData.viewers; let i = index">
                      <th scope="row">{{ i + 1}}</th>
                      <td>{{item[1]}}</td>
                      <td>{{item[0]}}</td>
                      <td>{{item[2]}}</td>
                      <td>
                        <button class="btn " (click)="deleteViewer(i)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-dash" viewBox="0 0 16 16">
                              <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                            </svg>Eliminar
                        </button>
                      </td>
                    </tr>  
                  </tbody>
                </table>                  
              </div>
      
            </ng-template>
          </ng-container>
      
          <ng-container *ngIf="!fileBlob" ngbNavItem>
            <a ngbNavLink>Documento <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-pdf" viewBox="0 0 16 16">
              <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"/>
              <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
            </svg></a>
            <ng-template ngbNavContent>
              <!-- pasa -->
                  <div *ngIf="validPdf && numSigners>0 && numViewers >0 ; else elseBlock4" class="mx-auto p-2" style="width: 300px;">
                    <h4>Documento a Firmar <span (click)="uploadContract()" class="text-success">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
                            <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"/>
                          </svg>
                        </span>
                    </h4>
                  </div>
                  <ng-template #elseBlock4>
                    <div class="mx-auto p-2" style="width: 300px;"><h4>Documento a Firmar</h4></div>
                  </ng-template>
      
                  <div class="row">
                    <div class="col-11">
      
                      <h4 class="p-3">Selecciona al documento que sera firmado</h4>
                      <p>Tamaño del Archivo: {{ convertedActualFileSize }} (20 MB max.)</p> 
                      <label class="btn btn-default btn-sm p-0">
                        <input  type="file" (change)="selectFile($event)" accept=".pdf" />
                      </label>
      
                      <div *ngIf="validPdf" class="pdf-container">
      
                        <pdf-viewer [src]="pdfContent"
                          [rotation]="0"
                          [original-size]="false"
                          [show-all]="true"
                          [fit-to-page]="true"
                          [zoom]="1"
                          [zoom-scale]="'page-width'"
                          [stick-to-page]="false"
                          [render-text]="true"
                          [external-link-target]="'blank'"
                          [autoresize]="true"
                          [show-borders]="false"
                          style="width: 100%; height: 100vh;"
                        ></pdf-viewer>
      
                      </div>    
                       
                    </div>
                  </div>
      
            </ng-template>
          </ng-container>
      
          <ng-container *ngIf="fileBlob" ngbNavItem>
            <a ngbNavLink>Acta</a>
            <ng-template ngbNavContent>
      
              <div *ngIf="fileBlob && numSigners>0 && numViewers >0 ; else elseBlock4" class="mx-auto p-2" style="width: 300px;">
                <h4>Documento a Firmar <span (click)="uploadContract()" class="text-success">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
                        <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"/>
                      </svg>
                    </span>
                </h4>
              </div>
              <ng-template #elseBlock4>
                <div class="mx-auto p-2" style="width: 300px;"><h4>Documento a Firmar</h4></div>
              </ng-template>
      
              <div class="row">
                <div class="col-11">
                  <div class="p-3">
                    <ngx-extended-pdf-viewer
                      [src]="fileBlob"
                      [height]="'auto'"
                      [showOpenFileButton]="false"
                      [showDrawEditor]="false"
                      [showStampEditor]="false"
                      [(zoom)]="auto"
                      [sidebarVisible]="true"
                      >
                    </ngx-extended-pdf-viewer>
                  </div>
                </div>
              </div>
      
            </ng-template>
          </ng-container>
      
        </nav>
            
        <div [ngbNavOutlet]="nav" class="mt-2">??</div>    
        
      
      </div>
      
        
        
      
        
        <div class="row"> 
          <div class="col">
          <div *ngIf="currentFile" class="p-10"> 
            <h4>Documento enviado, sera notificado una vez que los firmantes hayan completado el proceso...  </h4>
            <p>Se puede revisar el status del documento en la seccion: <a href="/#/administracion/hook-archive">Documentos -> Archivo Firma Electronica</a> </p>
          </div>  
          <div *ngIf="currentFile" class="progress my-3">
            <div
              class="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              attr.aria-valuenow="{{ progress }}"
              aria-valuemin="0"
              aria-valuemax="100"
              [ngStyle]="{ width: progress + '%' }"
            >
              {{ progress }}%
            </div>
          </div>
          
          <div *ngIf="message" class="alert alert-secondary" role="alert">{{ message }}</div>
          </div>
        </div> 
    </div>
  </div>  
